/**
 * orga-app-api - benutzerverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BenutzerForAdmin { 
    benutzer_id: string;
    mandant_id: string;
    anzeige_name?: string;
    entra_anzeige_name?: string;
    nachname?: string;
    vorname?: string;
    mail?: string;
    hat_login?: boolean;
    hat_entraid?: boolean;
    ist_aktiviert?: boolean;
}

